export var ColumnLayout;
(function (ColumnLayout) {
    ColumnLayout["SingleColumn"] = "SingleColumn";
    ColumnLayout["TwoColumns"] = "TwoColumns";
    ColumnLayout["ThreeColumns"] = "ThreeColumns";
    ColumnLayout["FourColumns"] = "FourColumns";
    ColumnLayout["LeftSideDominantTwoColumns"] = "LeftSideDominantTwoColumns";
    ColumnLayout["RightSideDominantTwoColumns"] = "RightSideDominantTwoColumns";
})(ColumnLayout || (ColumnLayout = {}));
export const TwoColumnsConfig = {
    columnsCount: 2,
};
export const SingleColumnConfig = {
    columnsCount: 1,
};
export const ThreeColumnsConfig = {
    columnsCount: 3,
};
export const FourColumnsConfig = {
    columnsCount: 4,
};
export const LeftSideDominantTwoColumnsConfig = {
    columnsCount: 2,
};
export const RightSideDominantTwoColumnsConfig = {
    columnsCount: 2,
};
const ColumnConfigs = new Map([
    [ColumnLayout.SingleColumn, SingleColumnConfig],
    [ColumnLayout.TwoColumns, TwoColumnsConfig],
    [ColumnLayout.ThreeColumns, ThreeColumnsConfig],
    [ColumnLayout.FourColumns, FourColumnsConfig],
    [ColumnLayout.LeftSideDominantTwoColumns, LeftSideDominantTwoColumnsConfig],
    [ColumnLayout.RightSideDominantTwoColumns, RightSideDominantTwoColumnsConfig],
]);
export const ColumnLayoutConfigProvider = {
    get: (columnLayout) => {
        const columnConfig = ColumnConfigs.get(columnLayout);
        if (!columnConfig) {
            throw Error(`Layout not found: ${columnLayout}`);
        }
        return columnConfig;
    },
};
